import React, { useContext, useEffect, useState } from 'react';
import {
	CronGeneratorContext,
	ICronGeneratorContext,
	TabOptions,
} from '../../../../../../cronGeneratorState/cronGeneratorContext';
import { Radio, RadioChangeEvent } from 'antd';
import EveryOption from './components/EveryOption';
import SpecificSelectors from './components/SpecificSelectors';
// import EveryStartingSelect from './components/EveryStartingSelect';
import EveryBetweenSelect from './components/EveryBetweenSelect';
import classNames from 'classnames';
import style from './MonthTab.module.scss';

interface ITab {
	isVisible: boolean;
}

const MonthTab: React.FC<ITab> = ({ isVisible }) => {
	const { setFieldValue } = useContext<ICronGeneratorContext>(CronGeneratorContext);
	// const [checkedOption, setCheckedOption] = useState<TabOptions>(TabOptions.EVERY_OPTION);
	const [checkedOption, setCheckedOption] = useState<TabOptions>(TabOptions.SPECIFIC_OPTION);
	const [everyResult, setEveryResult] = useState<string>('');
	const [specificResult, setSpecificResult] = useState<string>('');
	// const [everyStartingResult, setEveryStartingResult] = useState<string>('');
	const [everyBetweenResult, setEveryBetweenResult] = useState<string>('');

	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	const getCheckedValue = () => {
		switch (checkedOption) {
			case TabOptions.EVERY_OPTION:
				return everyResult;
			case TabOptions.SPECIFIC_OPTION:
				return specificResult;
			// case TabOptions.EVERY_STARTING_OPTION:
			// 	return everyStartingResult;
			case TabOptions.EVERY_BETWEEN_OPTION:
				return everyBetweenResult;
			default:
				// return everyResult;
				return specificResult;
		}
	};
	const fieldValue = getCheckedValue();

	useEffect(() => {
		setFieldValue('month', fieldValue || '*');
	}, [fieldValue]);

	const handleOptionChange = (e: RadioChangeEvent) => {
		setCheckedOption(e.target.value);
	};

	return (
		<Radio.Group
			className={containerClasses}
			value={checkedOption}
			onChange={handleOptionChange}
			data-test="MonthTab">
			<EveryOption onSetResult={setEveryResult} />
			<SpecificSelectors onSetResult={setSpecificResult} />
			{/*<EveryStartingSelect onSetResult={setEveryStartingResult} />*/}
			<EveryBetweenSelect onSetResult={setEveryBetweenResult} />
		</Radio.Group>
	);
};

export default MonthTab;
